// extracted by mini-css-extract-plugin
export default {"button":"CustomStarField_button__IIBny"};